// Transitions
export const FORM_VALID_TRANSITION_BANKING_DETAILS =
  "sizotsaFuneralCover/transition/bankingDetails/formValid";
export const FORM_INVALID_TRANSITION_BANKING_DETAILS =
  "sizotsaFuneralCover/transition/bankingDetails/formInvalid";


export const transitionBankingDetails = {
  formValid: () => ({ type: FORM_VALID_TRANSITION_BANKING_DETAILS }),
  formInvalid: () => ({ type: FORM_INVALID_TRANSITION_BANKING_DETAILS }),
};

// Input feild actions
export const SIZOTSA_BANKING_DETAILS =
  "sizotsaFuneralCover/bankingDetails/";
export const BANKING_DETAILS_SET_VALUE =
SIZOTSA_BANKING_DETAILS+"setValue/";
export const BANKING_DETAILS_SET_VALID =
SIZOTSA_BANKING_DETAILS +"setValid/";
// export const PERSONAL_DETAILS_EDIT =
// SIZOTSA_BANKING_DETAILS +"setEdit";

// export const TOOGLE_INSURANCE_TYPE_PRIVACY_NOTICE =
// ALLSURE_INSURANCE_INSURANCE_TYPE+"toogle/privacyNotice";

// export const  tooglePrivacyNotice=(value)=>({type: TOOGLE_INSURANCE_TYPE_PRIVACY_NOTICE, value})
export const setSfcBankingDetailsValue =(value)=>({type: BANKING_DETAILS_SET_VALUE, value})
export const setSfcBankingDetailsFieldValid =(error,fieldType)=>({type: BANKING_DETAILS_SET_VALID, error, fieldType})
// export const setPersonalDetailsEdit =(value)=>({type: PERSONAL_DETAILS_EDIT, value})



